<div class="card-table-details">
  <nf-table-layout
    hideTitle
    *nfLoader="loading"
    hideSearch
    [autoResizeGrid]="false"
    [isSectionTitle]="false"
    [gridOptions]="gridOptionsAccountDetails"
    [data]="rowAccountDetailsData"
    hideClearAll
  >
  </nf-table-layout>
</div>
<div *ngIf="hasValidationMessage">
  <p class="mdi mdi-alert-circle text-danger">{{ validationMessage }}</p>
</div>
